import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export const PasswordInput = ({ className = "", testId, ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input {...props} type={show ? "text" : "password"} data-testid={testId} className={`${className} pr-11`}/>
      <button type="button" onClick={() => setShow((s) => !s)} data-testid={testId ? `${testId}-toggle` : undefined} aria-label={show ? "Nascondi password" : "Mostra password"}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded-lg text-slate-500 hover:text-[#0D2B5A] transition-colors">
        {show ? <EyeOff className="w-4 h-4"/> : <Eye className="w-4 h-4"/>}
      </button>
    </div>
  );
};
